var React = require('react');

function Lotus (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M38,27c-9,0-8.451,4-19,4C8.452,31,9,27,0,27\r\n\t M25,19.75c0-5.321-2.631-9.302-6-13.75c-3.368,4.448-6,8.429-6,13.75c0,3.812,2.067,7.25,6,7.25C22.932,27,25,23.562,25,19.75z\r\n\t M15.958,16.833C13.246,13.998,7.996,13,2.107,13c1.684,5.141,2.801,9.069,6.748,11.625C11.929,26.616,14.542,27,19,27\r\n\tC19,22.292,18.955,19.965,15.958,16.833z M19,27c4.458,0,7.071-0.384,10.146-2.375c3.946-2.556,5.063-6.484,6.747-11.625\r\n\tc-5.889,0-11.138,0.998-13.851,3.833C19.045,19.965,19,22.292,19,27z M15.565,11C13.767,9.313,12.282,8.313,9,7v6.582\r\n\t M28.999,13.582V7c-3.282,1.313-4.768,2.313-6.565,4"}));
}

Lotus.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"38px","height":"38px","viewBox":"0 0 38 38","enableBackground":"new 0 0 38 38","xmlSpace":"preserve"};

module.exports = Lotus;

Lotus.default = Lotus;
